import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { agentConversationsQueryPrefix } from '@/hooks/queries/agents/use-agent-conversations';
import {
  listAgentConversationsPage,
  type AgentConversationsPage,
  type ListAgentConversationsOptions,
} from '@/services/agents/config';
import { useOrgStore } from '@/stores/org-store';

export type AgentConversationsPageParams = Required<
  Pick<ListAgentConversationsOptions, 'scope' | 'sort' | 'limit' | 'offset'>
> &
  Pick<ListAgentConversationsOptions, 'search'>;

export const agentConversationsPageQueryKey = (
  orgId: string | undefined,
  agentId: string | undefined,
  params: AgentConversationsPageParams,
) => [...agentConversationsQueryPrefix(orgId, agentId), params] as const;

export const useAgentConversationsPage = (
  agentId: string | undefined,
  params: AgentConversationsPageParams,
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<AgentConversationsPage, Error>({
    queryKey: agentConversationsPageQueryKey(orgId, agentId, params),
    queryFn: () => listAgentConversationsPage(orgId!, agentId!, params),
    enabled: !!orgId && !!agentId,
    // Paging and re-sorting swap the key; without this the grid unmounts to
    // a skeleton on every page click.
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    retry: 1,
  });
};
